import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IUserLogin, UserLogin, VCreateUserModel } from '../../models/user';
import { namespace } from 'vuex-class';
import { USER_MODULE_NAMESPACE, USER_SIGN_UP, USER_SIGN_UP_VERIFY_BLOCK } from '../../store/user/user-types.store';
import { Validator } from '../../utils/Validator.util';

const UserStore = namespace(USER_MODULE_NAMESPACE);

@Component
class Container extends Vue {

  rules: { require: any, email: any };
  dtForm: boolean;
  dtRegisteredSuccess: boolean;
  dtRegistrationForm: boolean;
  dtMode: "validation" | "registering"
  dtBlockCode: string;
  dtPasswordMode: "text" | "password";
  dtError: any;
  dtUserInfo: VCreateUserModel;
  dtIsLoading: boolean;
  @UserStore.Action(USER_SIGN_UP)
  storeUserSignUp: (payload: VCreateUserModel) => Promise<void>
  @UserStore.Action(USER_SIGN_UP_VERIFY_BLOCK)
  storeUserVerifyBlock: (blockCode: string) => Promise<{}>
  /**
   *
   */
  constructor() {
    super();
    this.dtPasswordMode = "password";
    this.dtMode = "validation";
    this.dtBlockCode = "";
    this.dtForm = false;
    this.dtRegistrationForm = false;
    this.dtError = null;
    this.dtIsLoading = false;
    this.dtRegisteredSuccess = false;

    this.dtUserInfo = new VCreateUserModel();

    this.rules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => Validator.IsValidEmail(value) || 'l\'email n\'est pas valide'
    }
  }
  get lblSetting() {
    return {
      ...require('@/locales/user').default
    }
  }

  get civilities(): { text: any, value: number }[] {
    return [
      { text: this.$t('LBL_MR'), value: 1 },
      { text: this.$t('LBL_MRS'), value: 2 },
      { text: this.$t('LBL_MRMRS'), value: 16 }
    ]
  }

  get agencyInfo() {
    return this.$store.getters.configuration.info
  }

  _clearTimeout: any
  handleValidate() {

    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      if (this.dtBlockCode.trim().length == 0) return;
      this.dtError = null;
      this.dtIsLoading = true;
      this.storeUserVerifyBlock(this.dtBlockCode)
        .then((res: any) => {
          this.dtMode = "registering";
          this.dtIsLoading = false;
          this.dtBlockCode = "";
          this.dtUserInfo = new VCreateUserModel({
            block_id: res.block_id,
            civility: 1,
            fk_user_role: this.agencyInfo.sign_up_roles[0].id
          });
          setTimeout(() => {
            this.handleFocus('firstnameRef');
          }, 50);
        })
        .catch(err => {
          this.dtError = err;
          this.dtIsLoading = false;
          this.dtMode = "validation";
          this.handleFocus('blockCodeRef');
        })
    }, 100);
  }

  handleRegister() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {

      if (!(this.$refs.registrationFormRef as any).validate()) {
        return;
      }

      this.dtIsLoading = true;
      this.dtError = null;

      this.storeUserSignUp(this.dtUserInfo)
        .then(res => {
          this.dtRegisteredSuccess = true;
          this.dtIsLoading = false;
        })
        .catch(err => {
          this.dtIsLoading = false;
          this.dtError = err
        })
    }, 100);
  }


  handleFocus(name: string) {
    if (this.$refs[name]) {
      this.dtPasswordMode = "password";
      (this.$refs[name] as any).focus(300)
    }
  }

  handleRergisteredSucess() {
    this.dtBlockCode = "";
    this.dtRegisteredSuccess = false
    this.dtUserInfo = new VCreateUserModel();
    this.dtError = false;
    setTimeout(() => this.$router.push('/'), 300);

  }

  handleShowPassword() {
    this.dtPasswordMode = this.dtPasswordMode === 'password' ? 'text' : 'password'
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/containers/signup/index.ts